// Reuse each account-owned cover across tables, filters and page visits.
function createCoverLoader({ cache, fetchBatch, scope, storage }) {
  const inFlight = new Map();
  const path = (account, id) => `/analytics/cover-image/?account_id=${encodeURIComponent(account)}&id=${encodeURIComponent(id)}`;
  const storedKey = (account, id) => `rr-cover-v1:${scope()}:${account}:${id}`;
  const peek = (account, id) => {
    if (!scope()) return null;
    const cached = cache.peek(path(account, id))?.data?.url;
    if (cached) return cached;
    try {
      const saved = JSON.parse(storage?.getItem(storedKey(account, id)) || 'null');
      if (saved?.expires > Date.now()) {
        cache.seed(path(account, id), { url: saved.url }, saved.expires - Date.now());
        return saved.url;
      }
    } catch { /* Private browsing and full storage retain memory caching. */ }
    return null;
  };
  async function load(account, ids, force = false) {
    const requested = [...new Set(ids.map(String))];
    const owner = scope();
    const key = id => `${owner}:${account}:${id}`;
    const missing = requested.filter(id => (force || !peek(account, id)) && !inFlight.has(key(id)));
    if (missing.length) {
      const work = Promise.resolve().then(() => fetchBatch(account, missing, force));
      for (const id of missing) {
        const item = work.then(result => {
          const url = result.covers?.[id] || null;
          if (url && owner && scope() === owner) {
            const ttl = url.startsWith('data:') ? 86400000 : 300000;
            cache.seed(path(account, id), { url }, ttl);
            try {
              storage?.setItem(storedKey(account, id), JSON.stringify({ url, expires: Date.now() + ttl }));
              const keys = Object.keys(storage || {}).filter(k => k.startsWith('rr-cover-v1:'));
              while (keys.length > 100) storage.removeItem(keys.shift());
            } catch { /* Quota unavailable; use memory cache. */ }
          }
          return { url, error: result.errors?.[id] };
        }).finally(() => inFlight.delete(key(id)));
        inFlight.set(key(id), item);
      }
    }
    const covers = {}, errors = {};
    await Promise.all(requested.map(async id => {
      const item = inFlight.get(key(id));
      const value = item ? await item : { url: peek(account, id) };
      covers[id] = value.url;
      if (value.error) errors[id] = value.error;
    }));
    return { covers, errors };
  }
  return { load, peek };
}
module.exports = { createCoverLoader };
